import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import contentHeightMonitor from "clfrontlib-scotiaweb-content-height-monitor";
import "canvas-core-react/lib/CanvasStyles.css";
import './index.scss';

const isMock = process.env.NODE_ENV === "development";

contentHeightMonitor();
 
ReactDOM.render(
  <App isMock={isMock} />,
  document.getElementById('root-mfe-dap-new-client-web-cl')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
